import { UserT } from '../../models/models';
import { ClientTypeE, ProjectStatusE, UserRoleE } from '../../models/enums';

const showWaitingActionIconFor = (role: UserRoleE, clientType: ClientTypeE, deliveryStatuses: ProjectStatusE[]) => {    
    return role !== UserRoleE.GlobalAdmin && role !== UserRoleE.GlobalAdminAndAdminContentManager && (
        clientType === ClientTypeE['Advertising Agency'] && deliveryStatuses.some(status => {
            return status === ProjectStatusE.WaitingForApprovalOfAdvertisingAgency
        })) || (
            clientType === ClientTypeE['Post/sound production'] && deliveryStatuses.some(status => status === ProjectStatusE.WaitingForApprovalOfPostProduction || status === ProjectStatusE.Opened)
        ) || (
            clientType === ClientTypeE['Broadcaster'] && deliveryStatuses.some(status => status === ProjectStatusE.ApprovedAndSentToBroadcaster)
        );
};

export default showWaitingActionIconFor;